import { BreadcrumbProvider } from "@/ui-components/ui/breadcrumb/breadcrumb-context";
import DynamicBreadcrumb from "@/ui-components/ui/breadcrumb/breadcrumb-url";
import GlobalSearch from "@/ui-components/ui/global-search";
import SideMenu from "@/ui-components/utils/menu-items/side-menu";
import TopBar from "@/ui-components/utils/menu-items/top-bar";
import { Building2, CircleUserRound } from "lucide-react";
import { ReactElement } from "react";

const ContactsRootComponent = ({ children }: { children: ReactElement }) => {
  return (
    <div className="flex flex-col h-full">
      <BreadcrumbProvider>
        <TopBar>
          <>
            <DynamicBreadcrumb />
            <GlobalSearch />
            <div className="flex-1"></div>
          </>
        </TopBar>
        <div className="flex grow">
          <SideMenu
            items={[
              {
                icon: <CircleUserRound />,
                link: "/contacts/persons",
                title: "Personen",
              },
              {
                icon: <Building2 />,
                link: "/contacts/organisations",
                title: "Unternehmen",
              },
            ]}
          />
          <div className="grow">{children}</div>
        </div>
      </BreadcrumbProvider>
    </div>
  );
};

export default ContactsRootComponent;
